
/* START_TEMPLATE */
define('hbs!app/views/templates/analytics',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers.analyticsCustomTemplate || (depth0 != null ? depth0.analyticsCustomTemplate : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"analyticsCustomTemplate","hash":{},"data":data}) : helper))) != null ? stack1 : "");
},"useData":true});
Handlebars.registerPartial('app/views/templates/analytics', t);
return t;
});
/* END_TEMPLATE */
;
